export default "__VITE_ASSET__DhYF5IXo__"